'use strict';

DoohApps
.factory('CampaignSchedule', ['restApi', function (restApi) {
    var controllerName = 'Campaign/';

    return {
        updateCampaignSchedule: function (successCallback, campaignSchedule) {
            restApi.PutApiMethod(successCallback, controllerName + 'PutCampaignSchedule', campaignSchedule);
        },
        addCampaignSchedule: function (successCallback, campaignSchedule, RepeatData) {
            restApi.PostApiMethod(successCallback, controllerName + 'PostCampaignSchedule', campaignSchedule, RepeatData);
        },
        deleteCampaignSchedule: function (successCallback, deletedSchedule) {
            restApi.DeleteApiMethod(successCallback, controllerName + 'DeleteCampaignSchedule', deletedSchedule);
        },
        validateCampaignSchedule: function (successCallback, campaignSchedule) {
            restApi.DeleteApiMethod(successCallback, controllerName + 'ValidateCampaignSchedule' + campaignSchedule);
        },
        getScheduleList: function (successCallback, data) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetScheduleList', data);
        },
        getCampaignsForSchedule: function (successCallback, data) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetCampaignsForSchedule', data);
        },
        getDevicesForSchedule: function (successCallback, data) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetDevicesForSchedule', data);
        },
        createCampaignSchedule: function (successCallback, campaignSchedule, RepeatData) {
            restApi.PostApiMethod(successCallback, controllerName + 'PostCampaignSchedules', campaignSchedule, RepeatData);
        },
        getRepeatPlaceHolders: function (successCallback, campaignSchedule, RepeatData) {
            restApi.PostApiMethod(successCallback, controllerName + 'GetRepeatPlaceHolders', campaignSchedule, RepeatData);
        },
        updatePriorities: function (successCallback, events) {
            restApi.PostApiMethod(successCallback, controllerName + 'UpdatePriorities', events);
        },
        updateCampaignScheduleEvent: function (successCallback, campaignSchedule) {
            restApi.PutApiMethod(successCallback, controllerName + 'PutCampaignScheduleEvent', campaignSchedule);
        },
        getRepeatEnd: function (successCallback, campaignSchedule, RepeatData) {
            restApi.PostApiMethod(successCallback, controllerName + 'GetRepeatEnd', campaignSchedule, RepeatData);
        },
        getEventOverlapInfo: function (successCallback, campaignSchedule) {
            restApi.PostApiMethod(successCallback, controllerName + 'GetEventOverlapInfo', campaignSchedule);
        },
        areRepeatEventsWithSamePriority: function (successCallback, data) {
            restApi.GetApiMethod(successCallback, controllerName + 'AreRepeatEventsWithSamePriority', data);
        },
    }
}])
